<div class="mydocma-dialog-container">

  <div class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title">
      {{'CO.bimModels.bimModelSelection.title' | translate}}
    </div>
    <div>
      <button mat-icon-button type="button" (click)="closeDialog()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body">
    <div class="modal-content">
      <mydocma-co-bim-model-modal-item *ngFor="let bimModel of modelsWithThumbs" [bimModel]="bimModel"
                                       [isSelected]="bimModel.id === selected?.id"
                                       (selectedModelEvent)="onBimModelSelection($event)">
      </mydocma-co-bim-model-modal-item>
    </div>

  </div>
  <div class="mydocma-dialog-footer">
    <div style="margin-right: 10px">
      <button mat-stroked-button class="mydocma-dialog-btn"
              class="mat-focus-indicator mydocma-btn mat-stroked-button mat-button-base" (click)="closeDialog()">
        {{'CO.buttons.cancel' | translate}}
      </button>
    </div>
    <div>
      <button mat-stroked-button cdkFocusInitial [class.mydocma-dialog-btn-accent]="!!selected" (click)="select()"
              [disabled]="!selected">
        {{'CO.buttons.next' | translate}}
      </button>
    </div>
  </div>
</div>
